var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('DateInput',{staticClass:"mr-1",attrs:{"label":"Date from"},model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}}),_c('DateInput',{staticClass:"ml-1",attrs:{"label":"Date to"},model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }